// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/Navigation.css */

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  padding: 0.5rem 1rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding-left: 10px;
  padding-right: 10px;
}

.navbar-logo img {
  height: 30px;
}

.navbar-links {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
}

.navbar-links li {
  margin-right: 1rem;
  position: relative;
}

.navbar-links a {
  text-decoration: none;
  color: #333;
  font-weight: 500;
}

.logout-button {
  padding: 0.5rem 1rem;
  border: 1px solid #333;
  border-radius: 4px;
  background: none;
  cursor: pointer;
  font-weight: 500;
}

.logout-button:hover {
  background-color: #f0f0f0;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #ffffff;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  z-index: 1;
  min-width: 200px;
}

.dropdown-content a {
  color: #333;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: #f0f0f0;
}

.navbar-links .dropdown:hover .dropdown-content {
  display: block;
}

.hamburger-menu {
  display: none;
}

@media (max-width: 768px) {
  .navbar-links {
    display: none;
  }

  .hamburger-menu {
    display: block;
  }
}

@media (min-width: 769px) {
  .hamburger-menu {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navigation.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,wCAAwC;EACxC,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;EACzC,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* src/components/Navigation.css */\n\n.navbar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: #ffffff;\n  padding: 0.5rem 1rem;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n\n.navbar-logo img {\n  height: 30px;\n}\n\n.navbar-links {\n  display: flex;\n  align-items: center;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.navbar-links li {\n  margin-right: 1rem;\n  position: relative;\n}\n\n.navbar-links a {\n  text-decoration: none;\n  color: #333;\n  font-weight: 500;\n}\n\n.logout-button {\n  padding: 0.5rem 1rem;\n  border: 1px solid #333;\n  border-radius: 4px;\n  background: none;\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.logout-button:hover {\n  background-color: #f0f0f0;\n}\n\n.dropdown-content {\n  display: none;\n  position: absolute;\n  background-color: #ffffff;\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);\n  z-index: 1;\n  min-width: 200px;\n}\n\n.dropdown-content a {\n  color: #333;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n}\n\n.dropdown-content a:hover {\n  background-color: #f0f0f0;\n}\n\n.navbar-links .dropdown:hover .dropdown-content {\n  display: block;\n}\n\n.hamburger-menu {\n  display: none;\n}\n\n@media (max-width: 768px) {\n  .navbar-links {\n    display: none;\n  }\n\n  .hamburger-menu {\n    display: block;\n  }\n}\n\n@media (min-width: 769px) {\n  .hamburger-menu {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
